// Figma ex7axZ21JT9w5UShRn65vm, section 55:1122 (Heineken), frames 55:1123 (cover), 55:1224, 55:1192
import type { Case, Img } from "../types"

const own = (n: string, w: number, h: number): Img => {
    const src = `/work/heineken/${n}`
    return { id: src, src, w, h, widths: [...[800, 1600].filter((x) => x < w), w] }
}
const IMG = own

export const heineken: Case = {
    name: "Heineken",
    // The frames' own background (#939393 -> #f9f9f9) is hidden under a blurred
    // green image ("image 269"); these colours are its vertical average.
    theme: {
        page: "#337a28",
        gradient: "linear-gradient(180deg, #337a28 0%, #409129 50%, #337b28 100%)",
        stops: [
            [51, 122, 40, 0],
            [64, 145, 41, 0.5],
            [51, 123, 40, 1],
        ],
        fill: "#156c1a",
        line: "rgba(255, 255, 255, 0.4)",
        tone: "dark",
        title: "#ffffff",
        body: "#ffffff",
    },
    modules: [
        {
            type: "grid",
            columns: [
                {
                    w: 220,
                    cells: [
                        {
                            h: 220,
                            tag: {
                                logo: "/work/heineken/logo.svg",
                                logoBox: [20, 19, 87, 44],
                                text: "HEINEKEN\nBEER BRAND\n\nPRODUCT SITE",
                            },
                        },
                        { h: 626 },
                    ],
                },
                {
                    w: 443,
                    cells: [
                        { h: 443, image: IMG("1-1", 886, 886), phone: false },
                        {
                            h: 400,
                            card: {
                                title: "On the tap, at home",
                                body: "On the tap, at home. As the slogan says, it's a home tap from Heineken, allowing you to serve beers from different brands, on the tap, at home.",
                            },
                        },
                    ],
                },
                { w: 888, cells: [{ h: 221 }, { h: 622, image: { ...IMG("1-2", 1776, 1244), pos: "left center" } }] },
            ],
        },
        {
            type: "grid",
            phoneCenter: true,
            columns: [
                { w: 776, cells: [{ h: 846, keep: true, image: IMG("2-1", 1552, 1692) }] },
                { w: 776, cells: [{ h: 846, keep: true, image: IMG("2-2", 1552, 1692) }] },
            ],
        },
        {
            type: "grid",
            columns: [
                {
                    w: 488,
                    cells: [
                        { h: 189, image: IMG("3-1", 976, 378), phone: false },
                        { h: 654, image: { ...IMG("3-2", 976, 1308), pos: "center top" } },
                    ],
                },
                // (the framed screen keeps its own proportions: its white margin even all round)
                { w: 1066, cells: [{ h: 763, fit: true, image: { ...IMG("3-3e", 2132, 1526), pos: "center top" } }, { h: 80 }] },
            ],
        },
    ],
}
